import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetSellOrdersProps } from "@/services/sell-order.service";

import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber, isEmpty, parseTonInputToNumber } from "@/utils/query-string";

export interface SOFRProps {
  order_date?: Dayjs;
  account_number: Option;
  order_amount: string;
  fixation_type: string[];
  grain: number;
  ton: number;
  estados?: number[];
}

export const getSellOrderFilter = (
  event: SOFRProps,
): Partial<GetSellOrdersProps> => {
  let order_amount: number | undefined;
  const tonValue = parseTonInputToNumber(event?.ton);


  if (event?.order_amount) {
    const num = formatCurrencyInputToNumber(event.order_amount);

    if (!Number.isNaN(num)) {
      order_amount = Number(num.toFixed(2));
    }
  }

  return {
    ...(event?.order_date && dayjs(event?.order_date).isValid()
      ? {
          fecha: dayjs(event?.order_date).toISOString(),
        }
      : {}),
    ...(event?.estados?.length
      ? {
          estados: event?.estados,
        }
      : {}),
    ...(event?.account_number
      ? {
          nroCuenta: String(event?.account_number?.value),
        }
      : {}),
    ...(event?.order_amount && order_amount
      ? {
          monto: order_amount,
        }
      : {}),
    ...(event?.fixation_type
      ? {
          tipoFijacion: event?.fixation_type,
        }
      : {}),
    ...(isEmpty(tonValue)
      ? {}
      : {
          toneladas: tonValue,
        }),
    ...(event.grain
      ? {
          grano: event?.grain,
        }
      : {}),
  };
};
